import "./Loading.scss";

const Loading = () => {
  return (
    <div className="loadingContainer">
      <div className="ldsRing">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
